const compactFormatter = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const fullFormatter = new Intl.NumberFormat("en-US");

export const formatCompact = (value) => compactFormatter.format(value);
export const formatNumber = (value) => fullFormatter.format(Math.round(value));

export const formatSignedPercent = (value, digits = 1) => {
    const sign = value > 0 ? "+" : value < 0 ? "−" : "";
    return `${sign}${Math.abs(value).toFixed(digits)}%`;
};

export const pctChange = (before, after) => (before === 0 ? 0 : ((after - before) / before) * 100);

const dateOf = (iso) => new Date(`${iso}T00:00:00Z`);
const format = (options) => {
    const formatter = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", ...options });
    return (iso) => formatter.format(dateOf(iso));
};

/** "Oct 3" */
export const formatDay = format({ month: "short", day: "numeric" });
/** "Oct 3, 2026" */
export const formatDayYear = format({ month: "short", day: "numeric", year: "numeric" });
/** "Fri, Oct 3, 2026" */
export const formatWeekdayYear = format({ weekday: "short", month: "short", day: "numeric", year: "numeric" });
/** "Fri, Oct 3" */
export const formatWeekday = format({ weekday: "short", month: "short", day: "numeric" });
/** "Oct 26" */
export const formatMonth = format({ month: "short", year: "2-digit" });

export const addDays = (iso, days) => new Date(dateOf(iso).getTime() + days * 86400000).toISOString().slice(0, 10);
export const daysBetween = (from, to) => Math.round((dateOf(to) - dateOf(from)) / 86400000);
